import { useEffect, useState } from 'react';
import { useKindeAuth } from '@kinde-oss/kinde-auth-react';
import { setAuthTokenGetter } from '../../_lib/api-client';

interface AuthProviderProps {
  children: React.ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const { getToken, isAuthenticated, isLoading } = useKindeAuth();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Set up the token getter with the proper audience
    const tokenGetter = async () => {
      try {
        // Only try to get token if authenticated
        if (!isAuthenticated) {
          return null;
        }
        
        const token = await getToken({ audience: 'https://invitewithlove.com/api' });
        return token;
      } catch (error) {
        console.error('Error getting token with audience:', error);
        return null;
      }
    };

    setAuthTokenGetter(tokenGetter);
    setIsReady(true);
  }, [getToken, isAuthenticated]);

  // Don't render children until auth is set up
  if (!isReady || isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-rose-500 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};